/**
 * Shared UI dimension constants.
 * Toolbar control width is 20% smaller than the previous 220px for buttons, filters, and toggles.
 */
export const TOOLBAR_CONTROL_WIDTH_PX = 176;
